module.exports = __webpack_public_path__ + "static/img/1047@2x.d7c5c940.png";